import React, { Component } from 'react'
import Switch from './uiComponents/Switcher/Switcher'

class Checkbox extends Component {
  constructor (props) {
    super(props)

    this.state = {
      checkBoxValue: false
    }
  }

  componentDidMount() {
    const { value, schema } = this.props
    this.setState({
      checkBoxValue: value === schema.enum[0]
    })
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { schema, value  } = this.props
    const propValue = value === schema.enum[0]

    if (propValue !== this.state.checkBoxValue && prevProps.value !== this.props.value) {
      this.triggerToggle()
    }
  }

  triggerToggle = () => {
    const { onChange, schema, disabled, readonly } = this.props

    if (disabled || readonly) {
      return
    }

    this.setState({
      checkBoxValue: !this.state.checkBoxValue
    })

    const newValue = !this.state.checkBoxValue ? schema.enum[0] : schema.enum[1]

    onChange(newValue || undefined)
  }

  render () {
    const { disabled, readonly } = this.props
    const { checkBoxValue } = this.state
    return (
        <div className='checkbox-duc-wrapper'>
          <Switch
              disabled={disabled || readonly}
              onChange={this.triggerToggle}
              checked={checkBoxValue}
              data-test='switcher'
          />
        </div>
    )
  }
}

if (typeof window !== 'undefined') {
  window.uStoreDucs = window.uStoreDucs || []
  window.uStoreDucs.push({ name: 'checkbox', component: Checkbox, displayName: 'Checkbox' })
}

export default Checkbox
